No: No
Yes: Yes
RefuseGiftCard: Decline gift card?
useGiftCardTitle: A guide to using a gift card
useGiftCardDesc: After receiving a gift card, you can view the available merchants on the gift card detail page. You can choose to pay with your gift card directly if you order with your phone, or give the phone number to the server at the counter to use your gift card.
ReceivedSuccess: Successfully received
RefusedSuccess: Successfully declined
requestFail: 'Network error. Reason: {0}'
